var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.titleTop),expression:"titleTop"}]},[_c('TopBar',{attrs:{"pagetitle":_vm.title,"back-url":_vm.backurl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }